export const Document = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
      <path
        fill="#55565C"
        fillRule="evenodd"
        d="M2.696 2.232c0-.862.7-1.562 1.562-1.562H8.65a8.654 8.654 0 0 1 8.655 8.655v8.443c0 .862-.7 1.562-1.562 1.562H4.258c-.862 0-1.562-.7-1.562-1.562V2.232Zm13.51 7.43a2.49 2.49 0 0 0-2.49-2.49h-1.352a1.562 1.562 0 0 1-1.562-1.563V4.26a2.49 2.49 0 0 0-2.49-2.491H4.257a.465.465 0 0 0-.464.464v15.536c0 .256.208.464.464.464h11.483a.465.465 0 0 0 .465-.464V9.662ZM11.278 2.24c.402.59.622 1.293.622 2.018V5.61a.464.464 0 0 0 .464.465h1.351c.725 0 1.428.22 2.019.621a7.556 7.556 0 0 0-4.456-4.455Z"
        clipRule="evenodd"
      />
    </svg>
  )
}
